export function getEffectiveConfig (fallbackScreens = null) {
  const fallback = fallbackScreens || [];
  const stored = localStorage.getItem('dashboardConfig');
  if (!stored) return { screens: fallback };
  try {
    const parsed = JSON.parse(stored);
    if (parsed.headerConfig !== undefined) {
      localStorage.removeItem('dashboardConfig');
      return { screens: fallback };
    }
    return { screens: parsed.screens ?? fallback };
  } catch (e) {
    localStorage.removeItem('dashboardConfig');
    return { screens: fallback };
  }
}
